<template>
	<div class="container-fluid">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid wrapper-flexbox">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow overflow">
				<div class="row">
					<div class="col-sm-2">
						<p class="admin-header">Pedidos</p>
					</div>
					<div class="col-sm-offset-7 col-sm-2">
						<input type="text" class="admin-input" placeholder="Buscar N° de Orden" v-model="query">
					</div>
				</div>
				<div class="row row-fluid absolute">
					<div class="col-sm-12 table-responsive">
						<table-admin-order :remove="deleteOrder" :list="render_orders" :url="url" :query="query"></table-admin-order>
						<div v-if="!render_orders.length" class="text-center empty">No hay pedidos en la plataforma.</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<style scoped>
	input{
		margin-top: 10px;
	}
</style>

<script>
import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
import tableAdminOrder from '../../components/Admin/Admin-table-order.vue';
import { deleteOrder } from '../../store/actions';

export default {
	// ------ COMPONENTS ------

  components: {
    navigationAdmin,
    sidebarAdmin,
    tableAdminOrder,
  },

  // ------ DATA ------

  data() {
  	return {
  		url: 'admin/purchaseOrders',
  		query: ''
  	};
  },

	// ------ VUEX ------

	vuex: {
		getters: {
			orders: state => state.orders,
			current_user: state => state.current_user
		},
		actions: {
			deleteOrder
		}
	},

	// ------ RENDER ------

	computed: {
		render_orders() {
			return this.orders;
		}
	},

	// ------ METHODS ------

	methods: {
		remove(user) {
			// Send the admin to obtain his token to procced, and 
			// send the user that is going to remove.
			this.deleteUser(this.current_user, user);
		}
	}
};
</script>


// WEBPACK FOOTER //
// Admin-order.vue?93029f8e